/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon20Solid = forwardRef('NetConnectWifiIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 5.75a9.25 9.25 0 0 0-6.845 3.028 1.25 1.25 0 0 1-1.85-1.681 11.75 11.75 0 0 1 17.39 0 1.25 1.25 0 1 1-1.85 1.681A9.25 9.25 0 0 0 10 5.75Z" }),
        React.createElement("path", { d: "M10 10.75a4.249 4.249 0 0 0-3.266 1.53 1.25 1.25 0 0 1-1.921-1.599 6.75 6.75 0 0 1 10.374 0 1.25 1.25 0 0 1-1.92 1.6A4.25 4.25 0 0 0 10 10.75Z" }),
        React.createElement("path", { d: "M10 16.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" })));
});
